import { Component, ElementRef, AfterViewInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
    selector: 'modal-window',
    templateUrl: './modal-window.component.html'
})
export class ModalWindowComponent {

    _show: boolean = false;
    _content: any;

    @Input() set show(value: boolean) {
        this._show = value;
        if (this._show) {
            if (this.onShow) {
                this.onShow.emit();
            }
        } else {
            if (this.onHide) {
                this.onHide.emit();
            }
        }
        this.showChange.emit(this._show);
    }
    get show() {
        return this._show;
    }
    @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() windowClass: string;
    @Input() title: string;
    @Output() onShow: EventEmitter<any> = new EventEmitter();
    @Output() onHide: EventEmitter<any> = new EventEmitter();

    public get content(): any {
        return this._content;
    }

    public showModal(content: any = null) {
        this.show = true;
        if (content != null) {
            this._content = content;
        }
    }

    public hide() {
        this.show = false;
    }
}
